module.exports = __webpack_public_path__ + "static/media/mcafee.b40cf113.jpg";